import { useEffect } from "react";

const SITE = "Peptigen Labs";
const ORIGIN = "https://peptigenlabs.co.uk";
export const DEFAULT_OG_IMAGE = `${ORIGIN}/og-default.png`;

function upsert(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.getAttribute(k) !== v && el.setAttribute(k, v));
}

export function setCanonical(pathname) {
  const url = ORIGIN + (pathname === "/" ? "/" : pathname.replace(/\/+$/, ""));
  upsert('link[rel="canonical"]', { rel: "canonical", href: url });
  upsert('meta[property="og:url"]', { property: "og:url", content: url });
}

// Mirror <title> / description into og: and twitter: tags (guarded so the
// MutationObserver that calls this never loops). Pages that pass an image to
// usePageMeta set og:image themselves; everything else gets the branded default.
export function syncSocialMeta({ resetImage = false } = {}) {
  const title = document.title;
  const desc = document.head.querySelector('meta[name="description"]')?.getAttribute("content");
  if (title) {
    upsert('meta[property="og:title"]', { property: "og:title", content: title });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: title });
  }
  if (desc) {
    upsert('meta[property="og:description"]', { property: "og:description", content: desc });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: desc });
  }
  const og = document.head.querySelector('meta[property="og:image"]');
  const img = resetImage || !og?.getAttribute("content") ? DEFAULT_OG_IMAGE : og.getAttribute("content");
  upsert('meta[property="og:image"]', { property: "og:image", content: img });
  upsert('meta[name="twitter:image"]', { name: "twitter:image", content: img });
}

export default function usePageMeta(title, description, image) {
  useEffect(() => {
    if (title) document.title = title.includes(SITE) ? title : `${title} | ${SITE}`;
    if (description) upsert('meta[name="description"]', { name: "description", content: description });
    if (image) {
      const abs = image.startsWith("http") ? image : ORIGIN + image;
      upsert('meta[property="og:image"]', { property: "og:image", content: abs });
      upsert('meta[name="twitter:image"]', { name: "twitter:image", content: abs });
    }
    syncSocialMeta();
  }, [title, description, image]);
}
